module.exports = __webpack_public_path__ + "img/lc-header-updates.dcedead8.svg";